import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageheightDirective } from './pageheight.directive';
import { DragDropFileUploadDirective } from './drag-drop-file-upload.directive';
import { AlphaNumWithSpaceDirective } from './AlphaNumWithSpace.directive';
import { AlphaNumericUnderscoreDirective } from './alpha-numeric-underscore.directive';
import { FastTooltipDirective } from './fast-tooltip.directive';
import { EllipsisTooltipDirective } from './fd-ellipsis-tooltip.directive';
import { NativeTitleOverrideDirective } from './native-title-override.directive';

@NgModule({
  declarations: [
    PageheightDirective,
    DragDropFileUploadDirective,
    AlphaNumWithSpaceDirective,
    AlphaNumericUnderscoreDirective,
    FastTooltipDirective,
    EllipsisTooltipDirective,
    NativeTitleOverrideDirective
  ],
  imports: [CommonModule],
  exports: [
    PageheightDirective,
    DragDropFileUploadDirective,
    AlphaNumWithSpaceDirective,
    AlphaNumericUnderscoreDirective,
    FastTooltipDirective,
    EllipsisTooltipDirective,
    NativeTitleOverrideDirective
  ]
})
export class CustomDirectivesModule {}
